import { Api } from 'utils';

class MoneyService {

	static admin = {
		digital: {
			get: async (params?: any) => Api.createResponse('admin/money/digital',params),
			download: async (params?: any) => Api.createResponse('admin/money/digital/download',params),
			view: async (params?: any) => Api.createResponse('admin/money/digital/view',params),
		},
		physical: {
			get: async (params?: any) => Api.createResponse('admin/money/physical',params),
			download: async (params?: any) => Api.createResponse('admin/money/physical/download',params),
			view: async (params?: any) => Api.createResponse('admin/money/physical/view',params),
		},
		liquidity: {
			get: async (params?: any) => Api.createResponse('admin/money/liquidity',params),
			download: async (params?: any) => Api.createResponse('admin/money/liquidity/download',params),
			view: async (params?: any) => Api.createResponse('admin/money/liquidity/view',params),
		}
	}

}

export default MoneyService;